import LogoV2 from '@/app/components/LogoV2';
import {
  RedirectionPreAction,
  getRegisterUrlServerSide,
  getSignInUrlServerSide,
} from '@/app/utils/urlHelper';
import { useAnalytics } from '@/app/utils/useAnalytics';
import { useState } from 'react';

import { Theme, useMediaQuery } from '@material-ui/core';

import styles from './LandingHeaderV2.module.scss';
import { HamburgerMenu } from './components/HamburgerMenu/HamburgerMenu';
import { NavMenuList } from './components/NavMenuList/NavMenuList';
import { NavbarActionButtons } from './components/NavbarActionButtons/NavbarActionButtons';
import { useBodyFixed } from './hooks/useBodyFixed';

export type LandingHeaderV2Props = {
  onRegisterClick?: () => void;
  redirectUrl?: string;
  preAction?: RedirectionPreAction;
};

const LandingHeaderV2 = ({ onRegisterClick, redirectUrl, preAction }: LandingHeaderV2Props) => {
  const track = useAnalytics();

  const [isMobileNavActive, setisMobileNavActive] = useState(false);
  useBodyFixed(isMobileNavActive);

  const signInUrl = getSignInUrlServerSide(redirectUrl, preAction);
  const registerUrl = getRegisterUrlServerSide({ redirect_url: redirectUrl, action: preAction });

  const isShortLogo = useMediaQuery((theme: Theme) => theme.breakpoints.between('md', 1470)); // 1470 is right where we need to change the padding on the NavLink buttons which makes sense to also change the logo size
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return (
    <header className={styles.landingHeaderV2}>
      <div className={styles.headerContainer}>
        <div className={styles.headerContainerInner}>
          <LogoV2
            type={isShortLogo || isSmallScreen ? 'medrecruit-short' : 'medrecruit-full'}
            onClick={() => {
              track('Click nav Logo', {});
            }}
          />
          <NavMenuList
            setisMobileNavActive={() =>
              setisMobileNavActive(previousIsMobileNavActive => !previousIsMobileNavActive)
            }
            isMobileNavActive={isMobileNavActive}
            signInUrl={signInUrl}
            registerUrl={registerUrl}
            isSmallScreen={isSmallScreen}
          />
          <div className={styles.actionButtonsContainer}>
            <NavbarActionButtons
              onRegisterClick={onRegisterClick}
              signInUrl={signInUrl}
              registerUrl={registerUrl}
              isSmallScreen={isSmallScreen}
            />
            <HamburgerMenu
              onClick={() =>
                setisMobileNavActive(previousIsMobileNavActive => !previousIsMobileNavActive)
              }
              isSmallScreen={isSmallScreen}
              isOpen={isMobileNavActive}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default LandingHeaderV2;
